import { EditIcon, Trash2Icon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../shadcn/ui/table';
import Constants from '@/constants';
import { Colaborator } from '@/entities/colaborator';
import { useColaborator } from '@/hook/useColaborator';
import CustomInputPhoneMask from '@/utils/customInputPhoneMask';
import { getTokenFromStorage } from '@/utils/getToken';
import { jwtDecode } from 'jwt-decode';
import { TokenPayload } from '../navbar/tabs/MenuTabs';
import useCompany from '@/hook/useCompany';
import company from '@/entities/company';

type ColaboratorsProps = {
  data: Colaborator[];
  onColaboratorDelete: (index: number) => void;
  setOpen: (value: boolean) => void;
  open: boolean;
  setSelectedColaborator: (data: any) => void;
  setEdit: (value: boolean) => void;
  setIdToEdit: (value: number) => void;
};

const TableView: React.FC<ColaboratorsProps> = ({
  data,
  onColaboratorDelete,
  setOpen,
  setSelectedColaborator,
  setEdit,
  setIdToEdit,
  open,
}) => {

  const { deleteColaborator } = useColaborator();
  return (
    <div className="m-4 rounded-md sm:border">
      <Table>
        <TableHeader>
          <TableRow className='mx-2 bg-indigo-50'>
            {Constants.LISTA_COLUNAS_COLABORADORES.map((coluna) => (
              <TableHead className="h-10" key={coluna}>
                {coluna}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((colaborador, index) => (
            <TableRow className='mx-2' key={index}>
              <TableCell>{colaborador.name}</TableCell>
              <TableCell>{colaborador.email}</TableCell>
              <TableCell>{colaborador.cellPhone}</TableCell>
              <TableCell>
                {colaborador.company?.fantasyName}
              </TableCell>
              <TableCell>
                <div className="flex gap-2">
                  <button title="Apagar">
                    <Trash2Icon
                      onClick={() => {
                        onColaboratorDelete(index);
                        deleteColaborator(colaborador.id);
                      }}
                      size={26}
                      className="bg-red-600 hover:bg-red-800 rounded-md p-1"
                    />
                  </button>
                  <button
                    title="Editar"
                    onClick={() => {
                      setOpen(true);
                      setSelectedColaborator(colaborador);
                      setEdit(true);
                      setIdToEdit(colaborador.id);
                    }}
                  >
                    <EditIcon
                      size={26}
                      className="bg-lime-600 hover:bg-lime-800 rounded-md p-1"
                    />
                  </button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TableView;
